import {
    Avatar,
    Divider,
    ListItem,
    ListItemAvatar,
    ListItemText,
    styled,
} from "@mui/material";
import React, { Fragment } from "react";
import { Alert } from "../../typeDefs/configuration";
import { Error } from "@mui/icons-material";
import { hexToRgb } from "./utils/utils";

const StyledListItem = styled(ListItem, {
    shouldForwardProp: (p) => p !== "isLink",
})<{
    isLink: boolean;
}>(({ theme, isLink }) => ({
    paddingTop: "24px",
    paddingBottom: "24px",
    paddingLeft: "24px",
    ...(isLink && {
        cursor: "pointer",
        "&:hover": {
            background: `rgba(${hexToRgb(
                theme.palette.primary.main,
                "string"
            )}, 0.05)`,
        },
    }),
    ".MuiListItemText-primary": {
        fontWeight: "bold",
    },
    ".MuiListItemText-secondary": {
        color: theme.palette.primary.main,
    },
}));

type Props = {
    alert: Alert;
};

const AlertListItem = ({ alert }: Props) => {
    const onRedirect = () => {
        if (alert.LinkTo) window.location.href = alert.LinkTo;
    };

    const Icon = () => {
        switch (alert.Priority) {
            case "high":
                return <Error color="error" />;
            case "medium":
                return <Error color="warning" />;
            case "low":
                return <Error color="info" />;
        }
    };

    return (
        <Fragment>
            <StyledListItem isLink={!!alert.LinkTo} onClick={onRedirect}>
                <ListItemAvatar>
                    <Avatar sx={{ backgroundColor: "unset" }}>
                        <Icon />
                    </Avatar>
                </ListItemAvatar>
                <ListItemText primary={alert.Title} secondary={alert.Message} />
            </StyledListItem>
            <Divider />
        </Fragment>
    );
};

export default AlertListItem;
